import type { DefectCatalogItem } from '../contracts/availableLayers';
import type { Recipe } from '../contracts/recipes';
import { pas2161DefectOverlayAdapter } from './adapters/pas2161DefectOverlayAdapter';
import { windsorDefectOverlayAdapter } from './adapters/windsorDefectOverlayAdapter';
import {
  resolveOverlayTenantSlug,
  type DefectOverlayTenantOptions,
  type TenantDefectOverlayAdapter,
} from './tenantDefectOverlayAdapter';

const TENANT_DEFECT_OVERLAY_ADAPTERS: readonly TenantDefectOverlayAdapter[] = [
  windsorDefectOverlayAdapter,
  pas2161DefectOverlayAdapter,
];

export function listTenantDefectOverlayAdapters(): readonly TenantDefectOverlayAdapter[] {
  return TENANT_DEFECT_OVERLAY_ADAPTERS;
}

export function resolveTenantDefectOverlayAdapters(
  options?: DefectOverlayTenantOptions,
): readonly TenantDefectOverlayAdapter[] {
  const tenantSlug = resolveOverlayTenantSlug(options?.tenantId);
  if (!tenantSlug) {
    return [];
  }
  return TENANT_DEFECT_OVERLAY_ADAPTERS.filter(
    (adapter) => adapter.tenantSlug === tenantSlug,
  );
}

export function isCuratedOverlayRecipeId(recipeId: string): boolean {
  return TENANT_DEFECT_OVERLAY_ADAPTERS.some((adapter) =>
    adapter.recipeIds.has(recipeId),
  );
}

export function mergeAdaptersCatalog(
  defects: readonly DefectCatalogItem[],
  surveyTypes: readonly string[] | undefined,
  adapters: readonly TenantDefectOverlayAdapter[],
): readonly DefectCatalogItem[] {
  let merged = defects;
  for (const adapter of adapters) {
    merged = adapter.mergeCatalog(merged, surveyTypes);
  }
  return merged;
}

export function collectAdapterRecipes(
  adapters: readonly TenantDefectOverlayAdapter[],
): readonly Recipe[] {
  const byId = new Map<string, Recipe>();
  for (const adapter of adapters) {
    for (const recipe of adapter.getRecipes()) {
      byId.set(recipe.id, recipe);
    }
  }
  return Array.from(byId.values());
}
